import paths from "routes/paths";

/**
 * The pages a visitor opens without being signed in.
 *
 * The page sends a visitor without a session to the sign-in page from any other address
 * (index.jsx). These are reached by a link in an e-mail (confirm the address, set a new
 * password), by a link on the website or the sign-in page, and by a reload of any of them.
 * None of them needs a session.
 */
const PUBLIC_PATHS = [
  paths.cardLogin,
  paths.cardConfirmMail,
  paths.cardForgotPassword,
  paths.cardResetPassword,
  paths.simpleLogin,
  paths.simpleForgotPassword,
  paths.simpleResetPassword,
  paths.cardTechnicalIssue,
  // Missing until #136: opened directly or reloaded, they went to the sign-in page.
  paths.cardRegister,
  paths.cardResendConfirmation,
];

// The address confirmation link carries its token in the path.
const PUBLIC_PATTERNS = [/^\/authentication\/card\/confirm-email\/[^/]+$/];

export const isPublicPath = (pathname) =>
  PUBLIC_PATHS.includes(pathname) ||
  PUBLIC_PATTERNS.some((pattern) => pattern.test(pathname));

export default isPublicPath;
